import type { PresetLabelTreeNode } from '@loc/server/interface/preset'

import { useLocale } from '@/hooks/routes'


import { api } from '@/utils/api';
export function useLabelsTree() {
  const locale = useLocale()
  const { data, isLoading } = api.preset.labelsTree.useQuery(
    { language: locale || 'en' },
    { staleTime: 5 * 60 * 1000 },
  )

  return {
    tree: data?.data ?? [],
    isLoading,
  }
}

/** 从树中递归提取所有 leaf 节点 */
export function getLeafNodes(
  nodes: PresetLabelTreeNode[],
): PresetLabelTreeNode[] {
  return nodes.flatMap((node) =>
    node.children?.length
      ? getLeafNodes(node.children)
      : node.leaf
        ? [node]
        : [],
  )
}

/** 在三级树中搜索匹配的 leaf 节点 */
export function searchLeafNodes(
  nodes: PresetLabelTreeNode[],
  keyword: string,
): PresetLabelTreeNode[] {
  const lowerKeyword = keyword.toLowerCase()
  return getLeafNodes(nodes).filter((node) =>
    node.displayName.toLowerCase().includes(lowerKeyword),
  )
}
